import { LoadingRows } from "../../components/ui.jsx";
import { formatMetric } from "./utils.js";

export default function Metrics({ overview, loading }) {
  const items = [
    ["Shared companies", overview.companies],
    ["Shared people", overview.people],
    ["Company values", overview.current_values],
    ["Verified person emails", overview.verified_person_emails],
    ["Client workspaces", overview.workspaces],
    ["Catalog cache hits", overview.catalog_hits],
    ["Person cache hits", overview.person_catalog_hits],
    ["Provider failures", overview.failed_runs],
  ];

  if (loading && !overview.companies) return <LoadingRows count={2} />;
  return (
    <section className="@container">
      <div className="grid grid-cols-1 gap-4 @sm:grid-cols-2 @xl:grid-cols-4">
        {items.map(([label, value]) => (
          <div className="grid min-w-0 gap-2 rounded-xl bg-card px-4 py-5 shadow-soft" key={label}>
            <p className="truncate text-[11px] font-semibold uppercase tracking-[.08em] text-muted-foreground">{label}</p>
            <strong className="text-2xl font-bold tracking-[-0.02em]">{formatMetric(value)}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
